import { render, staticRenderFns } from "./ModalTerms.vue?vue&type=template&id=91c06976&scoped=true"
import script from "./ModalTerms.vue?vue&type=script&lang=js"
export * from "./ModalTerms.vue?vue&type=script&lang=js"
import style0 from "./ModalTerms.vue?vue&type=style&index=0&id=91c06976&prod&scoped=true&lang=css"
import style1 from "./ModalTerms.vue?vue&type=style&index=1&id=91c06976&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91c06976",
  null
  
)

export default component.exports